export const sendField = (payload, event) => ({
  type: 'SEND_FIELD',
  payload,
  event,
});
